import DeleteOutline from "@mui/icons-material/DeleteOutline";
import Edit from "@mui/icons-material/Edit";
import { ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";

type ChatHistoryCardMenuProps = {
  anchorEl: HTMLElement | null;
  open: boolean;
  editTitleLabel: string;
  deleteLabel: string;
  onClose: () => void;
  onEditTitle: () => void;
  onDelete: () => void;
};

export function ChatHistoryCardMenu({
  anchorEl,
  open,
  editTitleLabel,
  deleteLabel,
  onClose,
  onEditTitle,
  onDelete,
}: ChatHistoryCardMenuProps) {
  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      slotProps={{
        paper: {
          sx: {
            mt: 0.5,
            minWidth: 180,
            bgcolor: "var(--theme-surface)",
            border: "1px solid var(--theme-border)",
            borderRadius: 1.5,
            boxShadow: "0 8px 24px var(--theme-overlay-dark-20, rgba(0,0,0,0.2))",
          },
        },
      }}
    >
      <MenuItem
        onClick={() => {
          onClose();
          onEditTitle();
        }}
      >
        <ListItemIcon sx={{ color: "var(--theme-text-primary)" }}>
          <Edit fontSize="small" />
        </ListItemIcon>
        <ListItemText primary={editTitleLabel} />
      </MenuItem>
      <MenuItem
        onClick={() => {
          onClose();
          onDelete();
        }}
        sx={{ color: "var(--theme-error, #f44336)" }}
      >
        <ListItemIcon sx={{ color: "inherit" }}>
          <DeleteOutline fontSize="small" />
        </ListItemIcon>
        <ListItemText primary={deleteLabel} />
      </MenuItem>
    </Menu>
  );
}
